import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "sectionVariationId", "subSectionGroupId", "form", "title"]

  connect() {
    this.defaultFormAction = this.hasFormTarget ? this.formTarget.action : null
  }

  open(event) {
    if (event) {
      event.preventDefault()
    }

    if (!this.hasDialogTarget) {
      return
    }

    const trigger = event?.currentTarget
    const sectionVariationId = trigger?.dataset?.sectionVariationId
    const subSectionGroupId = trigger?.dataset?.subSectionGroupId
    const formAction = trigger?.dataset?.formAction
    const formMethod = trigger?.dataset?.formMethod
    const formFields = trigger?.dataset?.formFields
    const modalTitle = trigger?.dataset?.modalTitle

    if (this.hasFormTarget) {
      this.formTarget.reset()
      this.formTarget.action = formAction || this.defaultFormAction || this.formTarget.action
      this.applyMethod(this.formTarget, formMethod)
      this.applyFields(this.formTarget, formFields)
    }

    if (this.hasSectionVariationIdTarget) {
      this.sectionVariationIdTarget.value = sectionVariationId || ""
    }

    if (this.hasSubSectionGroupIdTarget) {
      this.subSectionGroupIdTarget.value = subSectionGroupId || ""
    }

    if (this.hasTitleTarget) {
      const fallbackTitle = this.titleTarget.dataset.defaultTitle || this.titleTarget.textContent
      this.titleTarget.textContent = modalTitle || fallbackTitle
    }

    this.showDialog()
  }

  close() {
    if (!this.hasDialogTarget) {
      return
    }

    if (this.dialogTarget.close) {
      this.dialogTarget.close()
    } else {
      this.dialogTarget.removeAttribute("open")
    }
  }

  closeOnSuccess(event) {
    if (!event?.detail?.success) {
      return
    }

    this.close()
  }

  showDialog() {
    if (this.dialogTarget.showModal) {
      this.dialogTarget.showModal()
    } else {
      this.dialogTarget.setAttribute("open", "open")
    }
  }

  applyMethod(form, method) {
    const normalized = (method || "").toLowerCase()
    const existing = form.querySelector("input[name='_method']")
    if (!normalized || normalized === "post") {
      if (existing) {
        existing.remove()
      }
      return
    }

    if (existing) {
      existing.value = normalized
      return
    }

    const methodInput = document.createElement("input")
    methodInput.type = "hidden"
    methodInput.name = "_method"
    methodInput.value = normalized
    form.appendChild(methodInput)
  }

  applyFields(form, fields) {
    if (!fields) {
      return
    }

    let parsed = null
    try {
      parsed = JSON.parse(fields)
    } catch (error) {
      parsed = null
    }

    if (!parsed) {
      return
    }

    Object.entries(parsed).forEach(([key, value]) => {
      const input = form.querySelector(`[name="sub_section[${key}]"]`)
      if (!input) {
        return
      }

      input.value = value == null ? "" : String(value)
    })
  }
}
